
  import { Vue, Component, Prop } from "vue-property-decorator";
  import FormInput from "@/components/form/FormInput.vue";

  @Component({
    components: {
      FormInput
    },
  })
  export default class PrefixedFormInput extends Vue {
    @Prop({ type: String, default: undefined }) readonly prefix?: string;
  }
